import React from 'react';
import { useSelector } from 'react-redux';
import { commonConfigurationSelector } from '../../redux/reducers/app/configuration';
import { CommonConfigurationContext } from './CommonConfigurationContext';

export function CommonConfigurationProvider({ children }) {
  const config = useSelector(commonConfigurationSelector);

  return (
    <CommonConfigurationContext.Provider value={config}>
      {children}
    </CommonConfigurationContext.Provider>
  );
}
